import React from "react";
import { Card, Space, Collapse, Divider, Timeline } from "antd";
import { DownOutlined } from "@ant-design/icons";
import endLocation from "../../assests/images/endLocation.png";
import startLocation from "../../assests/images/startLocation.png";
import { dateFormat } from "../../utils";

import doxIcon from "../../assests/images/dox-new.svg";
import nonDoxIcon from "../../assests/images/nondox-new.svg";
import serviceTypeIcon from "../../assests/images/serviceType.svg";
import travelTypeIcon from "../../assests/images/travelType.svg";

//  /Users/admin/Downloads/travelType.svg

const { Panel } = Collapse;

function AwbContainer({
  trackingResults,
  setActiveTrackingId,
  activeTracking,
}) {
  function formatLocation(location) {
    if (!location) return null;

    return [
      location?.address,
      location?.city,
      location?.state,
      location?.pincode,
    ]
      .filter(Boolean)
      .join(", ");
  }

  return (
    <div className="tracking-results">
      <Space direction="vertical" style={{ width: "100%" }}>
        {trackingResults.map(
          ({ orderInformation: item, statuses: statuses }, index) => {
            return (
              <Card
                key={index}
                style={{
                  width: "100%",
                  border: `2px solid ${
                    activeTracking == item.trackingId ? "#2E77D0" : "#D3D3D3"
                  }`,
                  borderRadius: "5px",
                }}
                onClick={() => {
                  setActiveTrackingId({ ...item, statuses });
                }}
              >
                {/* Collapse Component with AWB as the Header */}
                <Collapse
                  expandIcon={({ isActive }) => (
                    <DownOutlined rotate={isActive ? 180 : 0} />
                  )}
                  style={{ backgroundColor: "white", border: "none" }}
                >
                  <Panel
                    key="1"
                    showArrow={false} // Remove default arrow placement
                    header={
                      <div className="awb-header">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            {item?.documentType ? (
                              <img
                                style={{
                                  height: "36px",
                                  width: "36px",
                                }}
                                src={
                                  item?.documentType === "DOX"
                                    ? doxIcon
                                    : nonDoxIcon
                                }
                              />
                            ) : null}
                          </div>
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <p className="awb-text">
                              AWB:
                              <span className="awb-tracking">
                                {item?.trackingId}
                              </span>
                            </p>
                            <span className="awb-date">
                              {dateFormat(item?.createdAt) || ""}
                            </span>
                          </div>
                          <div style={{ display: "flex" }}>
                            {item?.serviceType ? (
                              <div
                                style={{
                                  border: "1px solid #B7B7B780",
                                  borderRadius: "3px",
                                  padding: "2px 5px",
                                  display: "flex",
                                  alignItems: "center",
                                  marginRight: 6,
                                }}
                              >
                                <img
                                  style={{ height: "20px", width: "20px" }}
                                  src={serviceTypeIcon}
                                />
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    marginLeft: 5,
                                  }}
                                >
                                  <p
                                    style={{
                                      margin: 0,
                                      color: "#5A636B",
                                      fontSize: "10px",
                                      height: "10px",
                                    }}
                                  >
                                    Service
                                  </p>
                                  <p
                                    style={{
                                      margin: 0,
                                      fontSize: "12px",
                                      fontWeight: "bold",
                                      height: "17px",
                                    }}
                                  >
                                    {item?.serviceType.toLowerCase() ==
                                    "standard"
                                      ? "Standard"
                                      : "Fast Track"}
                                  </p>
                                </div>
                              </div>
                            ) : null}
                            {item?.travelType ? (
                              <div
                                style={{
                                  border: "1px solid #B7B7B780",
                                  borderRadius: "3px",
                                  padding: "2px 5px",
                                  display: "flex",
                                  alignItems: "center",
                                  marginRight: 6,
                                }}
                              >
                                <img
                                  style={{ height: "20px", width: "20px" }}
                                  src={travelTypeIcon}
                                />
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    marginLeft: 5,
                                  }}
                                >
                                  <p
                                    style={{
                                      margin: 0,
                                      color: "#5A636B",
                                      fontSize: "10px",
                                      height: "10px",
                                    }}
                                  >
                                    Travel
                                  </p>
                                  <p
                                    style={{
                                      margin: 0,
                                      fontSize: "12px",
                                      fontWeight: "bold",
                                      height: "17px",
                                    }}
                                  >
                                    {item?.travelType.toLowerCase() == "air"
                                      ? "Air"
                                      : "Surface"}
                                  </p>
                                </div>
                              </div>
                            ) : null}
                          </div>
                          <DownOutlined
                            style={{ fontSize: "14px", color: "#A0A0A0" }}
                          />
                        </div>
                      </div>
                    }
                  >
                    <div>
                      <Timeline className="timeline">
                        <Timeline.Item
                          dot={
                            <div className="location">
                              <img
                                style={{ width: "30px" }}
                                src={startLocation}
                              />
                            </div>
                          }
                        >
                          <div className="sender-details-container">
                            <div>
                              <p className="mobile">
                                Sender: {item?.senderDetails?.sender_mobile}
                              </p>
                              <p className="location">
                                {formatLocation(item.sourceLocation)}
                              </p>
                            </div>
                          </div>
                        </Timeline.Item>

                        <Timeline.Item
                          dot={
                            <div className="location">
                              <img
                                style={{ width: "30px" }}
                                src={endLocation}
                              />
                            </div>
                          }
                        >
                          <div className="receiver-details-container">
                            <div>
                              <p className="mobile">
                                Receiver:{" "}
                                {item?.receiverDetails?.receiver_mobile}
                              </p>
                              <p className="location">
                                {formatLocation(item.destinationLocation)}
                              </p>
                            </div>
                          </div>
                        </Timeline.Item>
                      </Timeline>

                      <Divider plain />

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          marginTop: "10px",
                        }}
                      >
                        <div style={{ marginRight: "10px" }}>
                          <p className="awb-details-title">Original Wt.</p>
                          <p className="awb-details-content">{item?.weight}</p>
                        </div>
                        <span className="awb-divider"></span>
                        <div style={{ marginRight: "10px" }}>
                          <p className="awb-details-title">LBH</p>
                          <p className="awb-details-content">
                            {item?.volWeight}
                          </p>
                        </div>
                        <span className="awb-divider"></span>
                        <div style={{ marginRight: "10px" }}>
                          <p className="awb-details-title">Audited</p>
                          <p className="awb-details-content">{item?.audited}</p>
                        </div>
                      </div>
                    </div>
                  </Panel>
                </Collapse>
              </Card>
            );
          }
        )}
      </Space>
    </div>
  );
}

export default AwbContainer;
